import { createApiOperation } from "../api-client/create-api-operation";

export const Audits = {
  getDeletedItems: createApiOperation<never, "/Api/Audits/DeletedItems", "get">(
    "/Api/Audits/DeletedItems",
    "get",
    { file: true },
  ),
};
